import { render, staticRenderFns } from "./index.vue?vue&type=template&id=709cccc8"
import script from "./detailsAssetMasterTags.js?vue&type=script&lang=js&external"
export * from "./detailsAssetMasterTags.js?vue&type=script&lang=js&external"
import style0 from "./detailsAssetMasterTags.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports